"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingEmptyStateContent;
var _react = _interopRequireDefault(require("react"));
var _RequestStatus = _interopRequireDefault(require("../constants/RequestStatus"));
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _RequestApiType = _interopRequireDefault(require("../constants/RequestApiType"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function LoadingEmptyStateContent({
  requestApiType,
  requestStatus,
  emptyStateComponent,
  customLoadingSpinner,
  recommendedDomains = []
}) {
  if (requestApiType && requestStatus === _RequestStatus.default.LOADING) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex justify-content-center h-100"
    }, customLoadingSpinner || /*#__PURE__*/_react.default.createElement(_spinner.default, null));
  }
  if (!recommendedDomains.length > 0 && emptyStateComponent) return emptyStateComponent;
  return null;
}
LoadingEmptyStateContent.propTypes = {
  requestApiType: _propTypes.default.oneOf(_RequestApiType.default),
  requestStatus: _propTypes.default.oneOf(_RequestStatus.default),
  customLoadingSpinner: _propTypes.default.element,
  emptyStateComponent: _propTypes.default.element,
  recommendedDomains: _propTypes.default.array
};